import { render } from "./XAxis.vue?vue&type=template&id=5703ba8f"
import script from "./XAxis.vue?vue&type=script&lang=js"
export * from "./XAxis.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__